import { Card, Typography } from "antd";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import icon from "../../Assets/icon2.png";

import {
  Arrow,
  ChangeLanguage,
  DeleteAccount,
  History,
  LinkAccounts,
  ReportIssue,
  ResetPin,
  TAndC,
  PAndP,
  UserProfile,
} from "../../Assets/icons";
import { Routes } from "../../Utils/Constants/routes";
import "./index.css";
import { PhoneOutlined } from "@ant-design/icons";

const MoreScreen: React.FC = () => {
  const [language, setLanguage] = useState(localStorage.getItem("i18nextLng"));
  const { t, i18n } = useTranslation();
  const { push } = useHistory();

  const MoreCardDetails = [
    {
      key: "T&C",
      title: t("lblTermsAndConditions"),
      logoUrl: <TAndC className="moreItemIcons" />,
    },
    {
      key: "UserProfile",
      title: t("lblUserProfile"),
      logoUrl: <UserProfile className="moreItemIcons" />,
    },
    {
      key: "LinkAccount",
      title: t("lblLinkAccounts"),
      logoUrl: <LinkAccounts className="moreItemIcons" />,
    },
    {
      key: "ResetPin",
      title: t("lblResetPin"),
      logoUrl: <ResetPin className="moreItemIcons" />,
    },
    {
      key: "MobileNumbers",
      title: t("lblMobileNumbers"),
      logoUrl: <PhoneOutlined className="moreItemIcons mobileNumberMenuIcon" />
    },
    {
      key: "History",
      title: t("lblHistory"),
      logoUrl: <History className="moreItemIcons" />,
    },

    // {
    //   key: "ChangeLanguage",
    //   title:
    //     t("lblChangeLanguage") +
    //     ` - (${language === "en" ? t("lblHindi") : t("lblEnglish")})`,
    //   logoUrl: <ChangeLanguage className="moreItemIcons" />,
    // },

    {
      key: "ChangeLanguage",
      title:
        t("lblChangeLanguage") +
        ` - (${
          language === "en"
            ? t("lblHindi")
            : language === "hi"
            ? t("lblMarathi")
            : t("lblEnglish")
        })`,
      logoUrl: <ChangeLanguage className="moreItemIcons" />,
    },
    {
      key: "GrievanceRedressal",
      title: t("lblGrievanceRedressal"),
      logoUrl: <PAndP className="moreItemIcons" />,
    },
    {
      key: "ReportIssue",
      title: t("lblReportIssue"),
      logoUrl: <ReportIssue className="moreItemIcons" />,
    },
    {
      key: "DeleteAccount",
      title: t("lblDeleteAccount"),
      logoUrl: <DeleteAccount className="moreItemIcons  " />,
    },
    {
      key: "P&P",
      title: t("lblPrivacyAndPolicy"),
      logoUrl: <PAndP className="moreItemIcons" />,
    }
  ];

  const cardOnClick = (key: string) => {
    switch (key) {
      case "T&C":
        push(Routes.more + Routes.termsandconditions);
        break;
      case "P&P":
        push(Routes.more + Routes.privacyandpolicy);
        break;
      case "GrievanceRedressal":
        push(Routes.more + Routes.grievanceredressal);
        break;
      case "UserProfile":
        push(Routes.more + Routes.userprofile);
        break;
      case "ResetPin":
        push(Routes.more + Routes.changePassword);
        break;
      case "MobileNumbers":
        push(Routes.more + Routes.mobileNumbers);
        break;
      case "LinkAccount":
        push(Routes.linkAccounts);
        break;
      case "DeleteAccount":
        push(Routes.more + Routes.deleteAccount);
        break;
      case "ReportIssue":
        push(Routes.more + Routes.reportIssue);
        break;
      case "History":
        push(Routes.more + Routes.history);
        break;
      case "ChangeLanguage":
      if (language === "en") {
        setLanguage("hi");
        i18n.changeLanguage("hi");
      } else if (language === "hi") {
        setLanguage("mr");
        i18n.changeLanguage("mr");
      } else {
        setLanguage("en");
        i18n.changeLanguage("en");
      }

      break;
    }
  };

  return (
    <div className="col spaceBetween overflowAuto moreRoot">
      <div className="row spaceBetween width90P">
        {MoreCardDetails.map((item, index) => (
          <div key={index} className="width48 moreCardContainer">
            <Card hoverable={true} onClick={() => cardOnClick(item.key)}>
              <div className="row spaceBetween alignCenter">
                <div className="row spaceBetween alignCenter">
                  <div className="iconContainer">{item.logoUrl}</div>
                  <Typography.Text className="fontWeight600">
                    {item.title}
                  </Typography.Text>
                </div>
                <Arrow />
              </div>
            </Card>
          </div>
        ))}
      </div>
      <div className="ant-row alignBaseline">
        <img src={icon} className="inkLogo" alt="INK" />
        <Typography.Text className="fontWeight600">
          Version 1.0.1
        </Typography.Text>
      </div>
    </div>
  );
};

export default MoreScreen;
